import React, { useEffect, useRef, useState } from 'react';
import { animate, useInView } from 'framer-motion';
type CountUpProps = {
  to: number;
  className?: string;
};
export function CountUp({
  to,
  className
}: CountUpProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true
  });
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.4,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: v => setValue(Math.round(v))
    });
    return () => controls.stop();
  }, [inView, to]);
  return <span ref={ref} className={className} data-id="element-265" data-mp="w7t5cf3ziy4r">
      {value}
    </span>;
}